<template>
  <div no-body class="lku-arinv">
    <b-row class="ml-3 mr-3">
      <b-col lg="10">
        <b-input-group>
          <b-input-group-prepend>
            <label>Customer</label>
          </b-input-group-prepend>
          <b-form-input
            v-model="tblData.customer"
            placeholder="Name"
            :disabled="(model.customer_id || '') !== ''"
            @keyup.13.native="refresh()"
          ></b-form-input>
          <b-input-group-prepend>
            <span class="pt-2 mr-1">Outstand</span>
          </b-input-group-prepend>
          <select v-model="tblData.typeoutstand">
            <option value="1">Installment & Denda</option>
            <option value="2">Installment</option>
            <option value="3">Denda</option>
            <option value="4">Denda Lainnya</option>
            <option value>-ALL-</option>
          </select>
        </b-input-group>
        <b-row>
          <b-col md="12">
            <b-input-group>
              <b-input-group-prepend>
                <label>No.Kontrak</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="tblData.no_kontrak"
                @keyup.13.native="refresh()"
                placeholder="No Kontrak Pinjaman"
                :disabled="(model.customer_id || '') !== ''"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <!-- <b-col md="7">
            <b-input-group>
              <b-input-group-prepend>
                <span class="mt-2">Penggunaan</span>
              </b-input-group-prepend>
              <b-form-input
                v-model="tblData.uraian"
                @keyup.13.native="refresh()"
                placeholder="Description"
              ></b-form-input>
            </b-input-group>
          </b-col> -->
        </b-row>
      </b-col>
      <b-col lg="2">
        <b-button variant="success" style="width: 120px" @click="refresh()">
          <i class="fa fa-refresh"></i> Apply Filter
        </b-button>
        <b-button
          class="btn btn-secondary"
          style="width: 120px"
          @click="clearFilter()"
        >
          <i class="fa fa-eraser"></i>Clear Filter
        </b-button>
      </b-col>
    </b-row>
    <!-- <b-row v-if="lkuLoading" class="justify-content-center mb-2">
      <span style="color: blue">Loading data ...</span>
    </b-row> -->
    <b-card no-body class="mb-2">
      <b-table
        class="mb-0"
        ref="tblArinvOst"
        style="font-size: smaller"
        responsive
        small
        striped
        hover
        selectable
        :items="tblData.items"
        :fields="fields"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="updatetable"
        @row-clicked="selectItem"
        :tbody-tr-class="onRowSelected"
        show-empty
        :busy="isBusy" 
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(selected)="data" >
          <template v-if="selectedrow.includes(data.item.angsurankey)">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>

        <template v-slot:cell(seq)="data">
          {{ ((tblData.page-1)*tblData.limit) + (data.index + 1) }}
        </template>

        <!-- <template v-slot:cell(seq)="data">
          {{ data.index + 1 }}
        </template> -->

        <template v-slot:cell(tgl_jttempo)="data">
          <span v-if="data.item.tgl_jttempo">{{
            data.item.tgl_jttempo | moment("DD MMM YYYY")
          }}</span>
        </template>
        <template v-slot:cell(tgl_kontrak)="data">{{
          data.item.tgl_kontrak | moment("DD MMM YYYY")
        }}</template>
        <template v-slot:cell(model_pinjaman)="data">
          <span v-if="data.item.model_pinjaman == 'PAB'"
            >Angsuran#{{ data.item.angsuran_ke }}</span
          >
          <span v-else>{{ data.item.model_pinjaman }}</span>
        </template>
        <template v-slot:cell(outstand_pokok)="data">{{
          data.item.outstand_pokok>0.09?data.item.outstand_pokok:0 | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(outstand_bunga)="data">{{
          data.item.outstand_bunga < 1 ? 0 : data.item.outstand_bunga | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(outstand_denda)="data">{{
          data.item.outstand_denda | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(outstand_denda_lainnya)="data">{{
          data.item.outstand_denda_lainnya | numFormat("0,0.00")
        }}</template>
        
        <template v-slot:cell(outstand_total)="data">{{
          data.item.outstand_total < 1 ? 0 : data.item.outstand_total | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(wo_status)="data">
          <span v-if="data.item.wo_status">ON</span>
          <span v-else>OFF</span>
        </template>
        <template v-slot:empty="scope">
          <h6 class="text-center mt-2 mb-2">{{ scope.emptyText }}</h6>
        </template>
        <template v-slot:emptyfiltered="scope">
          <h6 class="text-center mt-2 mb-2">{{ scope.emptyFilteredText }}</h6>
        </template>
      </b-table>
    </b-card>

    <b-row>
      <b-col cols="4">
        <div class="pt-2">
          Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
          to
          <span v-if="tblData.page * tblData.limit > tblData.total">{{
            tblData.total
          }}</span>
          <span v-else>{{ tblData.page * tblData.limit }}</span>
          of {{ tblData.total }} entries
        </div>
      </b-col>
      <b-col cols="3">
        <b-row class="ml-2 mt-2">
          <span class="pt-1 pr-2">Limit per page</span>
          <b-form-select
            :options="[10, 15, 20, 25]"
            :plain="true"
            v-model="tblData.limit"
            size="sm"
            style="width: 80px !important"
          />
        </b-row>
      </b-col>
      <b-col cols="5">
        <b-pagination
          align="right"
          :total-rows="tblData.total"
          :per-page="tblData.limit"
          v-model="tblData.page"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.lku-arinv {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import pinjaman from "../../apis/pinjamankredit";

export default {
  data() {
    return {
      lkuLoading: false,
      fields: [
        {
            key: "selected",
            label: "Selected",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
          },
        {
          key: "seq",
          label: "#",
          tdClass: "ml-1",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          tdClass: "ml-1",
          sortable: true,
        },
        {
          key: "tgl_jttempo",
          label: "Tgl. Jth. tempo",
          thStyle: "width:90px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur",
          sortable: true,
        },
        {
          key: "model_pinjaman",
          label: "Model/Angsuran",
          sortable: true,
        },
        {
          key: "outstand_pokok",
          label: "Outstand. Pokok",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_bunga",
          label: "Outstand. Bunga",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_denda",
          label: "Outstand. Denda",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
         {
          key: "outstand_denda_lainnya",
          label: "Outstand. Denda Lainnya",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_total",
          label: "Outstand. Total",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "wo_status",
          label: "WO Status",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ],
      tblData: {
        items: [],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: "tgl_jttempo",
        sortDesc: false,
        customer_id: "",
        outstand: "1",
        typeoutstand:"2",
        model_pinjaman:'',tglsettl:'',no_kontrak:''
      },
      updatetable: false,
      selectMode: "multi",
      selected: [],
      isBusy:false,
    };
  },
  computed: {
    filterCustomer() {
      return this.tblData.customer;
    },
    filtercustcode() {
      return this.tblData.customer_id;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    filterCustomer: function (newval) {
      this.$emit("update:customer", newval);
    },
    filtercustcode: function (newval) {
      this.$emit("update:customer_id", newval);
    },
    pagechange: function (newval) {
      this.tblData.page = newval;
      this.refresh();
    },
    limitchange: function (newval) {
      this.data();
    },
  },
  props: ["model", "formdata", "selectedrow","modelpinjaman","tglsettl"],
  created: async function () {
    this.tblData.customer = this.model.custinfo || "";
    this.tblData.customer_id = this.model.customer_id || "";
    this.tblData.wo_status = this.model.wo_status || 0;
    this.tblData.pinjamankey = this.model.pinjamankey || "";
    this.tblData.no_kontrak =this.model.no_kontrak;
    this.tblData.model_pinjaman= this.model.model_pinjaman;
    if (this.tblData.customer) {
      if (this.formdata.items) {
        if (this.formdata.items[0].customer_id !== this.tblData.customer) {
          this.data();
        } else {
          for (var key in this.formdata) {
            this.tblData[key] = this.formdata[key];
          }
        }
      } else {
        this.data();
      }
    } else {
      if (this.formdata.items) {
        for (var key in this.formdata) {
          this.tblData[key] = this.formdata[key];
        }
      }
      this.data();
    }
  },
  methods: {
    onRowSelected(item){
      if(!item) return;
      item._rowVariant = this.selectedrow.includes(item.angsurankey)?'success':''
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      if(this.modelpinjaman){
        this.tblData.model_pinjaman= this.model.modelpinjaman;
      }
      if(this.tglsettl){
        this.tblData.tglsettl= this.tglsettl;
      }
      
      this.isBusy = true;
      console.log('this.tblData',this.tblData);
      const list = await pinjaman.pinjamanoutstanding(this.tblData);
      this.isBusy = false;
      this.tblData.items = list;
      this.updatetable = !this.updatetable;
    },
    selectItem(item, index) {
      // console.log(index);
      // this.$emit("click", item);
      this.tblData.selected = item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
      this.tblData.nomor = "";
      this.tblData.outstand = "";
    },
    keymonitor: function (event) {
      if (event.key == "Enter") {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblArinvOst.refresh();
      }
    },
    refresh() {
      this.data();
      this.$refs.tblArinvOst.refresh();
    },
  },
};
</script>
